module.exports = __webpack_public_path__ + "img/老板看报告插图.81768a1f.png";